import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./ModalApp.scss";
import classNames from "classnames";

interface Props {
  show: boolean;
  children: JSX.Element | JSX.Element[];
  title?: any;
  titleIcon?: JSX.Element;
  width?: number;
  onHide?:  () => void | null;
  customHeader?: string;
}

export const ModalApp = ({ 
  show, 
  children, 
  titleIcon=null, 
  width=null, 
  title="", 
  onHide = null, 
  customHeader 
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      scrollable={true}
      className={classNames("warning_modal nondraggable_card", "center_warning_modal")}
      show={show}
      onHide={onHide}
    >
      { onHide && 
        <Modal.Header closeButton className={classNames(customHeader)}>
          { titleIcon }
          {title ?? t("comman_word.warning")}
        </Modal.Header>
      }
      <Modal.Body style={{width: width ?? "auto"}}>
        {children}
      </Modal.Body>
    </Modal>
  );
};
